module.exports = __webpack_public_path__ + "static/coding-emails-e7c89cea8b715ea9f466ed3a444ef488.jpg";